import { useContext } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, TableContainer, Grid } from "@material-ui/core";
import { useHistory } from 'react-router-dom';
import { ClickableTableRow } from 'components';
import Moment from "react-moment";
import { ticketContext } from "views/Ticket/TicketContext";
import { applicationContext } from "helpers/services";



let TicketsWithSerialNumber = () => {
    let history = useHistory();

    let { customerServiceUsers, ticketStatuses, ticketTypes, ticketPriorities } = useContext(applicationContext);
    let { ticketsWithSameSerialNumber } = useContext(ticketContext);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="h4" color="textSecondary">Tickets with same serial number</Typography>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Ticket</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Type/Priority</TableCell>
                                <TableCell>Assignee</TableCell>
                                <TableCell>C.S. Assignee</TableCell>
                                <TableCell>Title</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {ticketsWithSameSerialNumber.map(ticket =>
                                <ClickableTableRow
                                    hover
                                    key={ticket.ticketNumber}
                                    onClick={(e) => {
                                        if (e.ctrlKey)
                                            window.open(`/ticket/${ticket.ticketNumber}/`);
                                        else
                                            history.push(`/ticket/${ticket.ticketNumber}/`)
                                    }}
                                >
                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                        <b>{ticket.ticketNumber}</b>
                                        <Typography variant="subtitle2">
                                            <Moment date={ticket.createdOn} format="L LT" />
                                        </Typography>
                                    </TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                        {ticketStatuses.find(x => x.id === ticket.ticketStatusId)?.name}
                                    </TableCell>

                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                        {ticketTypes.find(x => x.id === ticket.ticketTypeId)?.name}
                                        <Typography
                                            variant="subtitle2"
                                            style={{ color: ticketPriorities.getValueByKey(ticket.ticketPriorityId, 'id', 'color') }}
                                        >
                                            {ticketPriorities.getValueByKey(ticket.ticketPriorityId, 'id', 'description')}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        {ticket.assignee ? ticket.assignee : "unassigned"}
                                    </TableCell>
                                    <TableCell>
                                        {customerServiceUsers.getValueByKey(ticket.customerServiceAssignee) ?? "unassigned"}
                                    </TableCell>
                                    <TableCell>{ticket.title}</TableCell>
                                </ClickableTableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}

export default TicketsWithSerialNumber;